import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-descargar-listado-codigos',
  templateUrl: './descargar-listado-codigos.component.html',
  styleUrls: ['./descargar-listado-codigos.component.css']
})
export class DescargarListadoCodigosComponent implements OnInit {
  safeUrl: SafeResourceUrl;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const acccessToken = this.authService.getToken();

    const iframeUrl = `${environment.ADMIN_URL}dashboard/productos/listado-codigos?token=${acccessToken}`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrl);
  }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/descargar-listado-codigos/descargar-listado-codigos.component.ts